import { createActions } from "reduxsauce";

import { REDUX_KEY } from "../../../utils/constants";

export const { Types, Creators } = createActions(
  {
    setModalValues: {
      key: "",
      values: {},
    },
  },
  { prefix: `${REDUX_KEY.MODALS}_` }
);
